import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import {
	incidentExperimentTraitResource,
	incidentsInitialPageChecksResource,
	incidentsCustomFieldIdResource,
} from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { softwareIncidentsClassicRoute } from '@jira/router-routes__incidents-routes/src/softwareIncidentsClassicRoute.tsx';
import { IncidentsPageSkeleton } from '@jira/platform__skeletons/src/ui/incidents-page/IncidentsPageSkeleton.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { entryPoint } from './common/entryPoint.tsx';
import { entryPointDeprecated } from './common/entryPointDeprecated.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareIncidentsClassicRouteEntry: Route = createEntry(
	softwareIncidentsClassicRoute,
	() => ({
		group: 'classic-software',

		entryPoint() {
			return fg('corex_operandi_incidents_page_in_jira') ? entryPoint : entryPointDeprecated;
		},

		layout: classicSoftwareProjectLayout,
		skeleton: IncidentsPageSkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			projectContextResource,
			incidentsInitialPageChecksResource,
			incidentsCustomFieldIdResource,
		],

		meta: {
			reporting: {
				id: 'software-incidents-classic',
				packageName: camelCase('software-incidents-classic'),
				teamName: 'operandi',
			},
		},

		ufoName: 'software-incidents',
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
